import React from 'react';
import PropertyShow from '../off_market_properties/property_show';

type Props = {
  insightsPropertyId: string;
}

export default function Overview({
  insightsPropertyId
}: Props) {
  return (
    <PropertyShow
      fromConsole={true}
      fullscreen={false}
      hasProfile={true}
      insightsPropertyId={insightsPropertyId}
    />
  );
}
